<template>
	<div class="select-all px-4 display-flex flex-row flex-align-center" @click="onClick">
		<div class="check-box flex-centerize mr-1" :class="{ selected: isAllSelected }">
			<v-icon v-if="isAllSelected" class="check-icon">mdi-check</v-icon>
		</div>
		<div class="display-flex flex-align-start">Select all</div>
	</div>
</template>

<script>
export default {
	name: 'SelectAllMultiSelect',
	props: { isAllSelected: { type: Boolean, default: false } },
	methods: {
		onClick() {
			this.$emit('select-all');
		},
	},
};
</script>

<style scoped lang="scss">
.select-all {
	cursor: pointer;
	font-size: 12px;
	min-height: 33px;
	border-bottom: 1px solid var(--border-color);
	&:hover {
		background: var(--insert-data-item-hover-background);
	}

	.check-box {
		width: 14px;
		height: 14px;
		border-radius: 3px;
		background: var(--bg-color);
		border: 1px solid var(--primary-color);
		&.selected {
			background: var(--primary-color);
		}

		.check-icon {
			width: 8px;
			height: 6px;
			font-size: 14px;
			color: var(--bg-color);
		}
	}
}
</style>
